module.exports = __webpack_public_path__ + "img/vertical-bar-icon-21022022.86715966.svg";